export enum RefreshStrategy {
    HydrationWithoutMessage,
    HydrationWithMessage,
    Reload,
}
